module.exports = __webpack_public_path__ + "f5769630eb9b11eade0d80ac81d3a8b1.png";